import PageLayout from '@/components/PageLayout';
import SolarSumPc from '@/components/solarSumPage';
import SolarSumH5 from '@/componentsH5/solarSumPage';
import { isReadyLang, redirectTo404 } from '@/utils';

export default function SolarSumPage({ isMobile, SEO, categoryList, data }: any) {
    const SolarSum = !isMobile ? SolarSumPc : SolarSumH5;
    const productMap = !isMobile ? data.pc : data.h5;

    return (
        <PageLayout theme="gray">
            <SEO title="" description="" />
            <SolarSum categoryList={categoryList} productMap={productMap} />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: any) {
    if (locale !== 'en') {
        if (!isReadyLang(locale)) {
            return redirectTo404();
        }
    }

    let collectionData = null;
    try {
        collectionData = require(`@/data/collection/${locale}`);
    } catch (e) {
        collectionData = require(`@/data/collection/en`);
    }

    return {
        props: {
            data: {
                pc: collectionData(false),
                h5: collectionData(true),
            },
        },
    };
}
